import React from 'react';
import { Card } from 'antd';
import './style.scss';

const CardComponent = ({ loading, cardContent, className }) => {
  const classes = `custom-card ${className || ''}`;
  return (
    <Card className={classes} loading={loading} bordered={false}>
      {cardContent}
    </Card>
  );
};

export default CardComponent;
